var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./assets/data/medItems": "785b",
	"./assets/data/medItems.json": "785b",
	"./assets/data/prodItems": "f030",
	"./assets/data/prodItems.json": "f030",
	"./assets/img/bg-header.jpeg": "46c8",
	"./assets/img/coin.svg": "fb15",
	"./assets/img/dead-end.svg": "3751",
	"./assets/img/final-pop.svg": "6afb",
	"./assets/img/hand.svg": "4819",
	"./assets/img/inf.svg": "05ca",
	"./assets/img/lockdown.svg": "26c8",
	"./assets/img/med/ambulance.svg": "0f7b",
	"./assets/img/med/bee-robot.svg": "f4d0",
	"./assets/img/med/camp.svg": "d729",
	"./assets/img/med/drug.svg": "e1a2",
	"./assets/img/med/factory.svg": "5742",
	"./assets/img/med/hospital.svg": "9bf6",
	"./assets/img/med/nurse.svg": "2369",
	"./assets/img/med/vaccine.svg": "5b36",
	"./assets/img/modal-lockdown.svg": "55a0",
	"./assets/img/nav-med.svg": "4802",
	"./assets/img/nav-prod.svg": "627c",
	"./assets/img/nurse.svg": "b8ba",
	"./assets/img/pop-dead.svg": "5ad9",
	"./assets/img/pop-healed.svg": "44ba",
	"./assets/img/pop-infected.png": "e1a3",
	"./assets/img/pop-infected.svg": "16f5",
	"./assets/img/pop.svg": "8915",
	"./assets/img/prod/alco.svg": "1011",
	"./assets/img/prod/bunker.svg": "5bd1",
	"./assets/img/prod/car.svg": "d781",
	"./assets/img/prod/costume.svg": "1bd3",
	"./assets/img/prod/gloves.svg": "a910",
	"./assets/img/prod/grecha.svg": "2f2e",
	"./assets/img/prod/mask.svg": "4cd0",
	"./assets/img/prod/paper.svg": "458a",
	"./assets/img/reset.svg": "1eb8",
	"./assets/img/start-earth.png": "8ce4",
	"./assets/img/vaccine-bg.svg": "a698",
	"./assets/img/vaccine.svg": "38e9",
	"./assets/img/win.svg": "1f1e",
	"./assets/mp3/from-the-depths.mp3": "b398",
	"./assets/mp3/tap.mp3": "13da",
	"./assets/scss/_vars.scss": "6811",
	"./assets/scss/index.scss": "a41b",
	"./components/ButtonChip": "d269",
	"./components/ButtonChip.vue": "d269",
	"./components/Clock": "17e2",
	"./components/Clock.vue": "17e2",
	"./components/GamePause": "a1bf",
	"./components/GamePause.vue": "a1bf",
	"./components/Header": "0418",
	"./components/Header.vue": "0418",
	"./components/LockDown": "4a85",
	"./components/LockDown.vue": "4a85",
	"./components/LockTimeLeft": "8da5",
	"./components/LockTimeLeft.vue": "8da5",
	"./components/Menu": "fb62",
	"./components/Menu.vue": "fb62",
	"./components/ModalQA": "1a26",
	"./components/ModalQA.vue": "1a26",
	"./components/ModalReset": "8cb1",
	"./components/ModalReset.vue": "8cb1",
	"./components/NavBar": "d000",
	"./components/NavBar.vue": "d000",
	"./components/NavVaccine": "3e55",
	"./components/NavVaccine.vue": "3e55",
	"./components/ProdItem": "49cc",
	"./components/ProdItem.vue": "49cc",
	"./components/ProgressBar": "b6b4",
	"./components/ProgressBar.vue": "b6b4",
	"./components/TabMedicine": "69c7",
	"./components/TabMedicine.vue": "69c7",
	"./components/TabProduction": "a330",
	"./components/TabProduction.vue": "a330",
	"./components/Tooltip": "1f24",
	"./components/Tooltip.vue": "1f24",
	"./components/Vaccine": "f8c5",
	"./components/Vaccine.vue": "f8c5",
	"./components/svg/PauseIcon": "de7d",
	"./components/svg/PauseIcon.vue": "de7d",
	"./main": "56d7",
	"./main.js": "56d7",
	"./mixins/nFormatter": "913c",
	"./mixins/nFormatter.js": "913c",
	"./mixins/track": "f949",
	"./mixins/track.js": "f949",
	"./mixins/update": "e63d",
	"./mixins/update.js": "e63d",
	"./registerServiceWorker": "ddb8",
	"./registerServiceWorker.js": "ddb8",
	"./router": "a18c",
	"./router/": "a18c",
	"./router/index": "a18c",
	"./router/index.js": "a18c",
	"./store": "4360",
	"./store/": "4360",
	"./store/index": "4360",
	"./store/index.js": "4360",
	"./views/Game": "7d36",
	"./views/Game.vue": "7d36",
	"./views/GameOver": "29bf",
	"./views/GameOver.vue": "29bf",
	"./views/ShowQa": "35ce",
	"./views/ShowQa.vue": "35ce",
	"./views/Start": "d701",
	"./views/Start.vue": "d701",
	"./views/Win": "8038",
	"./views/Win.vue": "8038"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ec";